import React from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { PicEmptyPayoutPlan } from 'common/components/svgs';
import { ADD } from '../../constant';

const EmptyView = ({ setVisibleFn, role }) => {
  const { t } = useTranslation();

  return (
    <div className="body" style={{ background: 'white' }}>
      <div className="blank-tips">
        <div className="content">
          <div>
            <PicEmptyPayoutPlan />
          </div>
          <span className="tip">{t('cms.referral.payout_plan.no_data.blanktip')}</span>
          <If condition={role !== 'bd'}>
            <Button
              className="blank-create-btn"
              type="primary"
              onClick={() => {
                setVisibleFn(true, ADD);
              }}
              size="large"
            >
              {t('cms.referral.payout_plan.no_data.button.add')}
            </Button>
          </If>
        </div>
      </div>
    </div>
  );
};

export default EmptyView;
